import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import AccountDetailsModal from '../../AccountDetails/AccountDetailsModal'

const CreditAccountDetailsTrigger: FC<{ FormName: string }> = ({ FormName }) => {
  const selectFormValue = formValueSelector(FormName)

  const ID: number = useSelector((state) => selectFormValue(state, 'CreditAccID'))
  const hash: string = useSelector((state) => selectFormValue(state, 'CreditAccHash'))

  //@ts-ignore
  return <AccountDetailsModal name="CreditAccountDetails" disabled={!ID || !hash} ID={ID} hash={hash} />
}

export default CreditAccountDetailsTrigger
